module.exports = __webpack_public_path__ + "static/media/detail14.4a3278bc.jpg";